"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioManager = void 0;
var file_metadata_1 = require("./metadata/file-metadata");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @doc AudioManager
 */
var AudioManager = /** @class */ (function () {
    function AudioManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        /**
         * @type {string}
         */
        this.baseUrl = 'https://' + configuration.domain;
        /**
         * @type {string}
         */
        this.apiUrl = this.baseUrl + '/_api/audio';
    }
    /**
     * @param {string} path
     * @returns {Promise<FileMetadata>}
     */
    AudioManager.prototype.extractMetadata = function (path) {
        var params = {
            path: path,
        };
        return this.httpClient
            .get(this.apiUrl + "/metadata", params)
            .then(function (response) {
            return new file_metadata_1.FileMetadata(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    return AudioManager;
}());
exports.AudioManager = AudioManager;
//# sourceMappingURL=audio-manager.js.map